
import { mapState } from "vuex";
import MailIcon from "./MailIcon.vue";
import { subscribeUser } from "~/common/services/newsletter.service";

export default {
	components: {
		MailIcon,
	},
	data() {
		return {
			emailAddress: "",
			loading: false,
			focused: false,
			localLoading: false,
		};
	},
	computed: {
		...mapState("newsletter-banner", ["isSubscribing"]),
	},
	methods: {
		async onSubmit() {
			this.$store.commit("newsletter-banner/USER_SUBSCRIBING");
			this.localLoading = true;
			await subscribeUser(this.$axios, this.$config, {
				email: this.emailAddress,
			});
			this.$store.commit("newsletter-banner/USER_SUBSCRIBED");
		},
	},
};
